import type { Sort } from '@cognite/fdm-client';
import type { SearchSort, ViewReference } from '@cognite/sdk';

const DEFAULT_CHECKLIST_SORT_PROPERTY = 'startTime';

export const buildChecklistSearchSort = ({
  sort,
  checklistView,
}: {
  sort?: Sort;
  checklistView: ViewReference;
}): SearchSort[] => {
  const viewPropertyPrefix = [
    checklistView.space,
    `${checklistView.externalId}/${checklistView.version}`,
  ];

  if (!sort || sort.length === 0) {
    return [
      {
        property: [...viewPropertyPrefix, DEFAULT_CHECKLIST_SORT_PROPERTY],
        direction: 'descending',
      },
    ];
  }

  return sort.map((sortItem) => {
    const propertyKey = Object.keys(sortItem)[0];
    const sortOrder = Object.values(sortItem)[0];

    return {
      property: [...viewPropertyPrefix, propertyKey],
      direction: sortOrder === 'ASC' ? 'ascending' : 'descending',
    };
  });
};
